import React from 'react'
import PropTypes from 'prop-types'
import OwlCarousel from 'react-owl-carousel2'
import { Icon } from 'loyal-react'
import { Link } from 'react-router-dom'
import MediaQuery from 'react-responsive'

import '@loyal_molecules/card.css'
import '@loyal_template/showcases.css'
import '@loyal_modules/carousel/css/owl.carousel.css'
import '@loyal_modules/carousel/css/owl.theme.default.min.css'

const Showcase = ({ title = '', titleMobile = '', children, searchPage }) => (
  <div
    className={`showcard-products ml-mob-2 container-card-new container py-1 py-md-3 px-0 px-md-0`}
  >
    <div className='row mx-0'>
      <div className='col mr-auto mb-2 mx-0 px-0'>
        <h2
          className='txt-font-title color-title d-none d-md-block px-md-0 px-2 pt-0 pt-md-1 pt-xl-0'
          tabIndex='0'
        >
          {title}
        </h2>
        <h2
          className='txt-font-title color-title d-block d-md-none px-md-0 pt-1 px-0'
          tabIndex='0'
        >
          {titleMobile}
        </h2>
      </div>
      <MediaQuery minDeviceWidth={426}>
        <div className='col-auto'>
          <Link
            to={searchPage || '/search'}
            className='card-see-all d-block btn btn-sm btn-flat btn-icon txt-button txt-font-body btn-invert'
            title='vai para lista de benefícios'
          >
            Ver todos <Icon iconName='icon-sm icon_right' />
          </Link>
        </div>
      </MediaQuery>
    </div>
    <div className='bx-showcase-products pos-relative'>
      <div className='row row-eq-height w-100'>
        <MediaQuery minDeviceWidth={426}>
          <OwlCarousel
            className='showcase-carousel bx-slider w-100 mx-0 owl-carousel owl-theme px-1'
            options={options}
          >
            {children}
          </OwlCarousel>
        </MediaQuery>
        <MediaQuery maxDeviceWidth={425}>
          {children}
          <div className='col-12 mb-5 pb-2'>
            <Link
              to={searchPage || '/search'}
              className='btn btn-sm  txt-center txt-button btn-invert'
              title='vai para lista de benefícios'
            >
              Ver todos
            </Link>
          </div>
        </MediaQuery>
      </div>
    </div>
  </div>
)

const options = {
  margin: 10,
  autoplay: false,
  dots: false,
  rewind: true,
  loop: false,
  responsive: {
    0: {
      items: 2,
      margin: 0,
      rewind: true,
      loop: false
    },
    420: {
      items: 2,
      nav: true,
      rewind: true,
      loop: false
    },
    600: {
      items: 4,
      nav: true,
      rewind: true,
      loop: false
    },
    1000: {
      margin: 20,
      nav: true,
      rewind: true,
      loop: false,
      items: 4
    }
  },
  navClass: [
    'pos-absolute showcase-nav showcase-prev bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon',
    'pos-absolute showcase-nav showcase-next bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon'
  ],
  navText: [
    '<i class="icon icon_left icon-sm color-ui-white"></i>',
    '<i class="icon icon_right icon-sm color-ui-white"></i>'
  ]
}

Showcase.propTypes = {
  title: PropTypes.string.isRequired,
  titleMobile: PropTypes.string,
  children: PropTypes.any.isRequired,
  searchPage: PropTypes.string
}

export default Showcase



// WEBPACK FOOTER //
// ./src/features/Showcase/ShowcaseBenefits.js